// extracted by mini-css-extract-plugin
export default {"graphOuter":"SmallFutureGraph_graphOuter__QnR1-"};